import { render, staticRenderFns } from "./card-slot.vue?vue&type=template&id=053af0d8&"
import script from "./card-slot.vue?vue&type=script&lang=js&"
export * from "./card-slot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "card-slot.vue"
export default component.exports